<template>
  <div class="sobre px-0 pt-2" >
    <v-container fluid fill-height>

      <!-- Adicione o diálogo para a sugestão SUGESTAO DE QUESTAO -->
      <v-dialog v-model="showSuggestionDialog" max-width="500">
        <v-card>
          <v-card-title>Escreva sua sugestão</v-card-title>
          <v-card-text class="text-justify">
            <!-- Adicione a caixa de texto para a sugestão -->
            Se você encontrou algum problema nesse card ou gostaria de sugerir alguma mudança, ficaríamos muito agradecidos por seu feedback.
            <v-textarea v-model="suggestionText" label="Caixa de Sugestão" rows="5" :rules="[v => !!v || 'Campo obrigatório']"></v-textarea>
          </v-card-text>
          <v-card-actions>
            <!-- Adicione botões para salvar e fechar o diálogo -->
            <v-btn @click="saveSuggestion" color="primary" text class="ml-auto" v-if="suggestionText !== ''" >Salvar</v-btn>
            <v-btn @click="closeSuggestionDialog" color="red" text>Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <div class="d-flex justify-center"> <!-- Added flex container for centering -->
        <v-row justify="center">
          <v-col cols="12" sm="8" md="6" lg="12" class="text-center mx-auto lg:mx-0 pt-0"   style="max-width: 500px;">
            <v-progress-linear 
              class="progress-bar mt-0"
              height="10"
              :model-value="progressPercentage"
              color="primary"
              style="max-width: 500px;" 
            ></v-progress-linear>

            <v-card v-if="!isFinished" class="flashcard mx-auto" style="max-width: 500px; max-height: 72vh; overflow: auto; min-height: 72vh; display: flex; align-items: center;">
              <v-btn icon @click="openSuggestionDialog" 
                    style="
                      position: absolute;
                      top: 8px;
                      right: 8px;
                      padding: 4px;
                      border-radius: 4px;
                      max-width: 30px;
                      max-height: 30px;
                      background-color: rgba(255, 0, 0, 0.1);
                    ">
                <v-icon color="red">mdi-flag</v-icon>
              </v-btn>
              <v-card-text class="flashcard-content" style="width: 100%;">
                <template v-if="!showAnswer" class>
                  <!-- Exibindo a imagem da pergunta, se estiver presente -->
                  <div class="text-h5" :style="{ 'white-space': 'pre-line' }">{{ currentFlashcard.question }}</div>
                  <v-img v-if="currentFlashcard.questionImage" :src="currentFlashcard.questionImage" style="max-width: 60%; max-height: 50%; display: block; margin: 0 auto;"></v-img>

                </template>
                <template v-else>
                  <!-- <div class="text-h5">Pergunta</div> -->
                  <div class="text-h5-question mb-15" :style="{ 'white-space': 'pre-line' }">{{ currentFlashcard.question }}</div>
                  <!-- Utilizando a transição fade-transition -->
                  <v-divider class="my-4"></v-divider>
                  <!-- Exibindo a imagem da resposta, se estiver presente -->
                  <!-- <div class="text-h5">Resposta</div> -->
                  <div class="text-h5 mt-15" :style="{ 'white-space': 'pre-line' }">{{ currentFlashcard.answer }}</div>
                  <v-img class="mt-5" v-if="currentFlashcard.answerImage" :src="currentFlashcard.answerImage" style="max-width: 60%; max-height: 50%; display: block; margin: 0 auto;"></v-img>
                </template>
              </v-card-text>
            </v-card>

            <v-card v-else class="flashcard mx-auto" style="max-width: 500px; max-height: 72vh; overflow: auto; min-height: 72vh; display: flex; align-items: center;">
              <v-card-text class="flashcard-content">
                <div class="text-h5">Revisão Concluída!</div>
                <v-card-actions class="d-flex justify-center" v-if="!showAnswer">
                  <v-btn small color="primary" @click="saveCards">Finalizar</v-btn>
                </v-card-actions>
              </v-card-text>
            </v-card>

            <v-card-actions v-if="showAnswer && !isFinished" class="d-flex justify-center fixed-bottom right">
              <v-row class="d-flex justify-center" style="flex-wrap: wrap; width: 100%;">
                <!-- Botões de dificuldade -->
                <v-col cols="12" class="d-flex justify-center">
                  <v-btn small variant="outlined" color="error" @click="handleDifficulty('Muito difícil', currentFlashcard.refId, currentFlashcard.easiness)">Muito<br>difícil</v-btn>
                  <v-btn small variant="outlined" color="warning" @click="handleDifficulty('Difícil', currentFlashcard.refId, currentFlashcard.easiness)">Difícil</v-btn>
                  <v-btn small variant="outlined" color="success" @click="handleDifficulty('Fácil', currentFlashcard.refId, currentFlashcard.easiness)">Fácil</v-btn>
                  <v-btn small variant="outlined" color="info" @click="handleDifficulty('Muito fácil', currentFlashcard.refId, currentFlashcard.easiness)">Muito<br>fácil</v-btn>
                </v-col>
                <!-- Botão "Voltar para Pergunta" -->
                <v-col cols="12" class="d-flex justify-center mt-2">
                  <v-btn small variant="outlined" color="primary" @click="showAnswer = false">Voltar para Pergunta</v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
            
            <v-card-actions v-if="!showAnswer && !isFinished" class="d-flex justify-center fixed-bottom right">
              <v-btn  block small variant="outlined" color="primary" @click="showAnswer = true">Mostrar Resposta</v-btn>
            </v-card-actions>        

          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>


<script>
export default {
  data() {
    return {
      currentFlashcardIndex: 0,
      difficulties: ['Super Fácil', 'Fácil', 'Difícil', 'Super Difícil'],
      showAnswer: false,
      difficultyTracking: [], // Objeto para rastrear a dificuldade de cada card
      showSuggestionDialog: false,
      suggestionText: '',
    }
  },
  computed: {
    currentFlashcard() {
      return this.flashcards[this.currentFlashcardIndex];
    },
    isFinished() {
      return this.currentFlashcardIndex === null;
    },
    flashcards(){
      return this.$store.getters.flashcards
    },
    totalFlashcards() {
      return this.flashcards.length;
    },
    progressPercentage() {
      console.log((this.currentFlashcardIndex + 1) / this.totalFlashcards*100)
      return ((this.currentFlashcardIndex + 1) / this.totalFlashcards) * 100;
    }
  },
  methods: {
    openSuggestionDialog() {
      // Abre o diálogo de sugestão
      this.showSuggestionDialog = true;
    },
    closeSuggestionDialog() {
      // Fecha o diálogo de sugestão
      this.showSuggestionDialog = false;
      // Limpa o texto da sugestão
      this.suggestionText = '';
    },
    saveSuggestion() {
      // Implemente a lógica para salvar a sugestão, juntamente com as informações da questão atual
      // Pode incluir o envio para um servidor, armazenamento local, etc.
        const postSuggestion = {
          suggestionQuestion: this.currentFlashcard.question,
          suggestionrefId: this.currentFlashcard.refId,
          suggestionText: this.suggestionText
        };
        console.log(postSuggestion)
        this.$store.dispatch('postSuggestionFlashcards', postSuggestion)
          .then(() => {
            console.log("Suggestion successful.");
            // Reload the window after successful submission
            setTimeout(() => {
              this.closeSuggestionDialog();
            }, 1000); // 2000 milliseconds = 2 seconds
          })
          .catch((error) => {
            console.error("Error submitting data:", error);
            // Handle error scenario here if needed
          });
    
    },
    handleDifficulty(difficulty, refId, easiness) {
      // Aqui você pode implementar a lógica para salvar a dificuldade do flashcard
      // Atualizar a easiness com base na dificuldade percebida
      // (Por exemplo, aumente ou diminua a easiness com base na dificuldade relatada)
      
      if (difficulty === 'Muito fácil') {
          easiness = easiness + 0.2;
      } else if (difficulty === 'Fácil') {
          easiness = easiness + 0.1;
      } else if (difficulty === 'Difícil') {
          easiness = easiness - 0.1;
      } else if (difficulty === 'Muito difícil') {
          easiness = easiness - 0.2;
      }
      // Calcular o próximo intervalo com base na easiness
      if (easiness < 1.3) {
          easiness = 1.3;
      }
      if (easiness > 3.4) {
          easiness = 3.4;
      }
      //nextInterval = interval * easiness;


      this.difficultyTracking.push({ refId, easiness });
      this.moveToNextFlashcard();
    },
    moveToNextFlashcard() {
      this.currentFlashcardIndex++;
      this.showAnswer = false;

      // Salva a cada 5 cards respondidos (exceto no final)
      if (
        this.currentFlashcardIndex % 5 === 0 &&
        this.currentFlashcardIndex < this.flashcards.length
      ) {
        this.saveLastFive();
      }

      // Ao finalizar todos, salva os restantes (menos de 5)
      if (this.currentFlashcardIndex >= this.flashcards.length) {
        this.saveLastFive(true); // true = final
        this.currentFlashcardIndex = null;
        console.log(this.difficultyTracking);
      }
    },
    saveLastFive(isFinal = false) {
      if (this.difficultyTracking.length === 0) return;

      // Calcula quantos cards estão sendo salvos agora
      let qtdSalvos = 5;
      if (isFinal && this.difficultyTracking.length % 5 !== 0) {
        qtdSalvos = this.difficultyTracking.length % 5;
      }

      const start = this.difficultyTracking.length - qtdSalvos;
      const lastFive = this.difficultyTracking.slice(Math.max(0, start), this.difficultyTracking.length);

      if (lastFive.length === 0) return;

      const payload = {
        total: lastFive.length, // <-- Aqui está a diferença!
        difficultyTracking: lastFive,
      };

      this.$store.dispatch('saveCards', payload)
        .then(() => {
          if (isFinal) {
            this.$router.push('/webapp/decks');
          }
        })
        .catch((error) => {
          console.error("Error submitting data:", error);
        });
    },
    saveCards(){
      console.log(this.totalFlashcards)
      const payload = {
        total: this.totalFlashcards,
        difficultyTracking: this.difficultyTracking // Inclui o rastreamento de dificuldades no payload
      };
      const payload2 = {
        difficultyTracking: this.difficultyTracking // Inclui o rastreamento de dificuldades no payload
      };

      this.$store.dispatch('saveCards', payload)
        .then(() => {
          this.$router.push('/webapp/decks');
        })
        .catch((error) => {
          console.error("Error submitting data:", error);
          // Handle error scenario here if needed
        });


      // console.log("salvando agora a dificuldade")
      
      // this.$store.dispatch('saveDifficulty', payload2)
      //   .then(() => {
      //   })
      //   .catch((error) => {
      //     console.error("Error submitting data: Difficulty", error);
      //     // Handle error scenario here if needed
      //   });  
    }
  }
}
</script>

<style scoped>
.flashcard {
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.flashcard:hover {
  box-shadow: 0 8px 12px rgba(0, 0, 0, 0.15), 0 3px 6px rgba(0, 0, 0, 0.12);
}

.flashcard-content {
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 24px;
  
}

.progress-text {
  font-size: 14px;
  margin-bottom: 10px;
}

.text-h5 {
  font-size: 22px;
  font-weight: bold;
}

.text-h5-question {
  font-size: 22px;
}

.text-body-1 {
  .text-h5 {
  font-size: 22px;
  font-weight: bold;
}
}

.sobre {
  background-color: #f5f5f5;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.progress-bar {
  margin-bottom: 10px; /* Optional: Add margin to separate progress bar from content */
}
</style>
